import type { Static } from 'runtypes';
import { InstanceOf, Number, Record, String } from 'runtypes';

const DismissibleNoticesReportRunType = Record({
  timestamp: InstanceOf(Date),
  event: String,
  count: Number,
});

type DismissibleNoticesReportType = Static<typeof DismissibleNoticesReportRunType>;

export { DismissibleNoticesReportRunType };
export type { DismissibleNoticesReportType };
